import { render, staticRenderFns } from "./OnlineProjectDossier.vue?vue&type=template&id=b83e5f2c"
import script from "./OnlineProjectDossier.vue?vue&type=script&lang=js"
export * from "./OnlineProjectDossier.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports